<template>
    <div>
    <Modal
        class-name="vertical-center-modal"
        :value="showSetModel"
        :title="$t('detail')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'1000px','max-height':'800px'}">
        <Form ref="formDynamic" :model="formDynamic" :rules="ruleCustom" :label-width="80" >

             <div v-for="(item, index) in formDynamic.items" :key="index" class="itemWrap">
                <div v-if="formDynamic.items.length>1" class="circleIndex">{{index*1+1}}</div>
                <div style="display:flex;jutifyContent:flex-start;flex-wrap:wrap">
                    <FormItem   v-if=" languageKey.key1"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key1}`) "  :prop="'items.' + index + '.'+languageKey.key1" style="width:370px"
                        >
                        <Input v-model="item[languageKey.key1]" ></Input>
                          
                    </FormItem>
                    
                    <FormItem   v-if=" languageKey.key4"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key4}`) "  :prop="'items.' + index + '.'+languageKey.key4" style="width:370px"
                        >
                        <Input v-model="item[languageKey.key4]" ></Input>
                          
                    </FormItem>
                    <FormItem   v-if=" languageKey.key2"  :label="'Code' "  :prop="'items.' + index + '.'+languageKey.key2"  style="width:370px"
                        >
                        <Input  v-model="item[languageKey.key2]" ></Input>
                          
                    </FormItem>
                    <FormItem   v-if=" languageKey.key3"  :label="$t(`BasicProduct.funcBox.titleName.${languageKey.key3}`) "  :prop="'items.' + index + '.'+languageKey.key3"  style="width:370px"
                        >
                         <Input  v-model="item[languageKey.key3]" ></Input>
                    </FormItem>
                    
                 
                </div>
                 

             </div>

            
           

        </Form>

    </Modal>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'

    export default {
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object,
            languageKey:Object,
            DataType:String,
            initdata:[Array ,Object],
            isGener:{
                type:Boolean,
                default:false
            }
        },
        name: "Model6",
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '设置',//弹框标题
                formData: {//表单数据
                   
                }, 
                index: 1,
                formDynamic: {
                    items: [
                    ],
                },
                descText:''
               
            }
        },
        watch:{
            showSetModel(val){
                if(val){
                    
                }
            },
        },
        computed:{
            ...mapState(['local','selectId']),
             ruleCustom(){
                 return {//验证
                    orderId: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    
                    qty: [
                        {required: true, type:'number', message: this.$t('required'),trigger: 'blur' },
                    ],
                }
             } 

        },
        created(){
           
        },
        methods: {
     
            openOrClose(value) {
                if(value === true) {
                    let flag = this.editFormData.IndentyName
                    if(Array.isArray(flag)){
                        this.formDynamic.items = flag
                    }

                    if(Object.prototype.toString.call(flag)=='[object Object]'){
                        let list = []
                        for(let key  in flag){
                            list.push({"Code":key,LanguageKey:'',"Name-CN":flag[key],"Name-EN":flag[key]})
                        }
                        this.formDynamic.items = [...list]
                    }
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formDynamic.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            }
        }
    }
</script>

<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
     .ivu-modal-body {
        max-height: 800px;
        // overflow-y: scroll;
        overflow: auto;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.delButton {
    /deep/ .ivu-form-item-content {
    margin-left: 20px !important;
    }
}
.itemWrap{
    &:not(:first-child){
        
        border-top: 1px dashed #666;
        padding-top: 15px;
    }
}
.circleIndex{
    display: inline-block;
    background: #2db7f5;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    color: white;
}
</style>

